<template>
  <modeShareCard />
</template>

<script>
import modeShareCard from '@/components/modeShareCard.vue';

export default {
  components: {
    modeShareCard,
  },
};
</script>

<style lang="scss" scoped></style>
